import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { appClientMapping } = stateEnum

const initialState = {
  selectedAppClient: {},
}

const appClientMappingSlice = createSlice({
  name: appClientMapping,
  initialState,
  reducers: {
    resetAppClientMapping: (state) => {
      state.selectedAppClient = {}
    },
    setSelectedAppClient: (state, action) => {
      state.selectedAppClient = action.payload
    },
  }, 
})
export const { resetAppClientMapping, setSelectedAppClient } =
  appClientMappingSlice.actions

export default appClientMappingSlice.reducer
